export default {
    data: () => ({
        dataTableSearch: ""
    }),
    computed: {
        dataTableFooterProps() {
            return {
                "items-per-page-options": [15, 30, 50, 100]
            };
        }
    },
    methods: {
        normalizeDataTableText(value) {
            if (value === null || value === undefined) {
                return "";
            }

            if (Array.isArray(value)) {
                return value.map(item => this.normalizeDataTableText(item)).join(" ");
            }

            if (typeof value === "object") {
                return Object.values(value).map(item => this.normalizeDataTableText(item)).join(" ");
            }

            return String(value)
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .trim();
        },
        dataTableCustomFilter(value, search, item) {
            const terms = this.normalizeDataTableText(search).split(/\s+/).filter(Boolean);
            if (terms.length === 0) {
                return true;
            }

            const haystack = this.normalizeDataTableText(item && item.__search ? item.__search : value);
            return terms.every(term => haystack.includes(term));
        },
        withDataTableSearch(item, values) {
            return {
                ...item,
                __search: values.map(value => this.normalizeDataTableText(value)).join(" ")
            };
        },
        mapServerSort(sortBy, sortMap, fallback = "id") {
            if (!Array.isArray(sortBy) || !sortBy[0]) {
                return fallback;
            }

            return sortMap[sortBy[0]] || sortBy[0] || fallback;
        },
        resetServerTablePage(fetchCallback) {
            if (!this.options || this.options.page === 1) {
                fetchCallback();
                return;
            }

            this.options = {
                ...this.options,
                page: 1
            };
        }
    }
}
